var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18,0H6A6.0048,6.0048,0,0,0,0,6V18a6.0048,6.0048,0,0,0,6,6H18a6.0048,6.0048,0,0,0,6-6V6A6.0048,6.0048,0,0,0,18,0Zm4,18a3.9989,3.9989,0,0,1-4,4H6a3.9989,3.9989,0,0,1-4-4V6A3.9989,3.9989,0,0,1,6,2H18a3.9989,3.9989,0,0,1,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,6a6,6,0,1,0,6,6A6.0048,6.0048,0,0,0,12,6Zm0,9.6A3.6,3.6,0,1,1,15.6,12,3.5977,3.5977,0,0,1,12,15.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 18.46,
    cy: 5.46,
    r: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.479f6b73.svg";
export { ForwardRef as ReactComponent };